const NS = 'MarketSummaryMonthlyBlock';
const CLS = 'marketSummaryMonthlyBlock';

export class MarketSummaryMonthlyBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$currentMonthContentMicron = this.$element.find(`.${CLS}-month--current .${CLS}-month-content-micron`);
		this.$currentMonthArrowIcon = this.$element.find(`.${CLS}-month--current .${CLS}-month-content-arrow`);
		this.$previousMonthContentMicron = this.$element.find(`.${CLS}-month--previous .${CLS}-month-content-micron`);

		this.$element.on(`${CLS}.update`, (event, params) => {
			let monthMicrons = params.monthMicrons;

			// Handle null values
			if(_.isNil(monthMicrons)) {
				console.error(`${NS}::Error`, 'Please supply the monthlyMicron object');
				this.renderError();
				return;
			}

			if(_.isNil(monthMicrons.currentMonth)) {
				console.error(`${NS}::Error`, 'Please supply a currentMonth value');
				this.renderError();
				return;
			}

			if(_.isNil(monthMicrons.previousMonth)) {
				console.error(`${NS}::Error`, 'Please supply a previousMonth value');
				this.renderError();
				return;
			}

			let currentMonth = parseInt(monthMicrons.currentMonth);
			let previousMonth = parseInt(monthMicrons.previousMonth);

			// Handle values if they are a valid integer…
			if(!_.isFinite(currentMonth)) {
				console.error(`${NS}::Error`, 'Please supply a valid currentMonth integer value');
				this.renderError();
				return;
			}

			if(!_.isFinite(previousMonth)) {
				console.error(`${NS}::Error`, 'Please supply a valid previousMonth integer value');
				this.renderError();
				return;
			}

			this.update(currentMonth, previousMonth);
		});
	}

	update(currentMonth, previousMonth) {
		this.$currentMonthContentMicron.html(currentMonth);
		this.$previousMonthContentMicron.html(previousMonth);

		if(currentMonth >= previousMonth) {
			this.$currentMonthArrowIcon.addClass(`${CLS}-month-content-arrow--up`);
		}
		else if(currentMonth < previousMonth) {
			this.$currentMonthArrowIcon.addClass(`${CLS}-month-content-arrow--down`);
		}
	}

	renderError() {
		this.$currentMonthContentMicron.html('-');
		this.$previousMonthContentMicron.html('-');
		this.$currentMonthArrowIcon.removeClass(`${CLS}-month-content-arrow--up`);
		this.$currentMonthArrowIcon.removeClass(`${CLS}-month-content-arrow--down`);
	}
}
